import { Observable } from 'rxjs/Observable';
import { AngularFirestoreCollection, AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/map';

interface Note {
  name: string;
  description?: number;
  img?: string;
}
@Component({
  selector: 'app-closed-guard-passing',
  templateUrl: './closed-guard-passing.component.html',
  styleUrls: ['./closed-guard-passing.component.css']
})
export class ClosedGuardPassingComponent implements OnInit {

  notesCollection2: AngularFirestoreCollection<Note>; // collection
  notes2: Observable<Note[]>; // observable

  notesCollection3: AngularFirestoreCollection<Note>; // collection
  notes3: Observable<Note[]>; // observable

  notesCollection4: AngularFirestoreCollection<Note>; // collection
  notes4: Observable<Note[]>; // observable

  notesCollection5: AngularFirestoreCollection<Note>; // collection
  notes5: Observable<Note[]>; // observable

  public show: boolean = false;
  public show2: boolean = false;

  public link1: string = "/sideControlAttacking";
  public link1txt: string = "Side Control Attacking";
  public link2: string = "/openGuardPassing";
  public link2txt: string = "Open Guard Passing";

  toggleDiv() {
    this.show = false;
    this.show2 = true;
  }

  toggleDiv2() {
    this.show = true;
    this.show2! = false;
  }

  constructor(private afs: AngularFirestore) { }

  ngOnInit() {

    this.notesCollection2 = this.afs.collection('passingPositions') // reference
    this.notes2 = this.notesCollection2.valueChanges() // observable data

    this.notesCollection3 = this.afs.collection('passingPositions', ref => {
      return ref.where('name', '==', 'Closed guard passing')
    }) // reference
    this.notes3 = this.notesCollection3.valueChanges() // observable data

    this.notesCollection4 = this.afs.collection('passingPositions').doc('closedGuardPassing')
      .collection('closedGuardPassingReactions', ref => {
        return ref.where('name', '==', 'Double Unders Pass')
      }) // reference
    this.notes4 = this.notesCollection4.valueChanges() // observable data

    this.notesCollection5 = this.afs.collection('passingPositions').doc('closedGuardPassing')
      .collection('closedGuardPassingReactions', ref => {
        return ref.where('name', '==', 'Standing Guard Break')
      }) // reference
    this.notes5 = this.notesCollection5.valueChanges() // observable data
  }

}



// WEBPACK FOOTER //
// ./src/app/closed-guard-passing/closed-guard-passing.component.ts